module.exports = __webpack_public_path__ + "static/media/witness_01.642e9947.svg";